import React from 'react';
import PropTypes from 'prop-types';
import { component } from 'Helpers/PropTypes';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import List from './List';

const styles = () => ({
  header: {},
  list: {},
  footer: {},
});

const ListView = ({
  classes,
  highlightSelected,
  HeaderComponent,
  HeaderProps,
  ListItemComponent,
  ListItemComponentProps,
  ListProps,
  FooterComponent,
  FooterProps,
}) => {
  return (
    <>
      <HeaderComponent
        className={classes.header}
        {...HeaderProps}
      />
      <List
        className={classes.list}
        highlightSelected={highlightSelected}
        ListItemComponent={ListItemComponent}
        ListItemComponentProps={ListItemComponentProps}
        {...ListProps}
      />
      {FooterComponent && (
        <FooterComponent
          className={classes.footer}
          {...FooterProps}
        />
      )}
    </>
  );
};

ListView.defaultProps = {
  highlightSelected: false,
  HeaderProps: {},
  ListProps: {},
  FooterProps: {},
  ListItemComponentProps: {},
  FooterComponent: null,
};

ListView.propTypes = {
  classes: PropTypes.object.isRequired,
  highlightSelected: PropTypes.bool,
  HeaderComponent: component.isRequired,
  HeaderProps: PropTypes.object,
  ListItemComponent: component.isRequired,
  ListItemComponentProps: PropTypes.object,
  ListProps: PropTypes.object,
  FooterProps: PropTypes.object,
  FooterComponent: component,
};

export default withStyles(styles)(ListView);
